import React from "react";
import "./CompletionModal.css";
import images from "../../../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const CompletionModal = (props) => {
  const { isOpen, onClose, score, total } = props;
  const history = useHistory();

  if (!isOpen) return null;

  const percentage = Math.round((score / total) * 100);

  const handleDoneClick = () => {
    const message = "completed";

    window.postMessage(message, "*");

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(message);
    }

    const event = new CustomEvent("practiceCompleted", { detail: message });
    window.dispatchEvent(event);
    history.push("/ncert");

    onClose();
  };

  return (
    <div className="modal-overlay" id="completion-modal-overlay">
      <div className="modal" id="completion-modal">
        <button id="modal-close" onClick={onClose}>
          ×
        </button>

        <div className="modal-icon">
          <img
            src={images.ChoicesCorrect}
            alt="correct_answer"
            style={{ height: "48px" }}
          />
        </div>

        <h2 className="appreciation">Excellent Work!</h2>
        <p className="appriciation-msg">
          You've successfully completed all the practice questions. Great job on
          your learning journey!
        </p>

        <div className="modal-score-box" id="score-box">
          <div className="score">
            {score}/{total}
            <p className="completed-question">Questions Completed</p>
          </div>
          <div className="progress-bar-complete">
            <div className="progress" style={{ width: `${percentage}%` }} />
          </div>
          <div className="percentage">{percentage}% Complete</div>
        </div>

        <button
          id="completion-done-btn"
          className="modal-done"
          onClick={handleDoneClick}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default CompletionModal;
